<template>
  <div class="creditCycle">
    <Row class="content">
      <Col span="12" class="ad">
        <h3>{{$t('other.w86')}}</h3>
        <p>{{$t('other.w87')}}</p>
        <div class="tip">
          <i></i>
          <span>{{$t('label.w135')}}</span>
        </div>
        <ul class="desc">
          <li>{{$t('other.w88')}}</li>
          <li>{{$t('other.w89')}}</li>
          <li>{{$t('other.w90')}}</li>
          <li>{{$t('other.w91')}}</li>
        </ul>
      </Col>
      <Col span="12" class="bg">
        <div class="img-bg"></div>
      </Col>
    </Row>
    <div class="loanMsg">
      <h3 class="tit">{{$t('title.w45')}}</h3>
      <Row class="wrMsg">
        <Col span="12">
          <Row class="loan-input">
            <Col span="12" class="block mar-b40">
              <span>{{$t('label.w2')}}</span>
              <Input :value="amount" readonly/>
              <span class="s1">{{$t('label.w5')}}</span>
              <p class="s2">
                <span v-show="amount">【{{amount | upmoney}}】</span>
              </p>
            </Col>
            <Col span="12" class="block mar-b40">
              <span>{{$t('label.w3')}}</span>
              <Input v-model="rate"/>
              <span class="s1">%</span>
            </Col>
            <!-- <Col span="12" class="block">
              <span>优惠券</span>
              <Select>
                <Option value="1">10元管理费减免</Option>
                <Option value="2">100元管理费减免</Option>
                <Option value="3">105元管理费减免</Option>
              </Select>
            </Col> -->
            <Col span="12" class="block">
              <span>{{$t('label.w80')}}</span>
              <Select v-model="loanCycleDay">
                <Option :value="1">{{$t('option.w37')}}</Option>
                <Option :value="2">{{$t('option.w38')}}</Option>
              </Select>
            </Col>
          </Row>
        </Col>
        <Col span="12" class="block1">
          <p>
            <span>{{$t('label.w82')}}</span>
            <span>({{$t('label.w136')}})</span>
          </p>
          <Input type="textarea" v-model="description"/>
          <span class="s3"><span :class="{'text-warning':description.length>20}">{{description.length}}</span>/20</span>
        </Col>
      </Row>
    </div>
    <div class="confirmMsg">
      <h3 class="tit">{{$t('title.w46')}}</h3>
      <p class="time">
        <i class="icon-active">
          <p class="desc">{{$t('other.w92')}}</p>
        </i>
        <span>{{$t('label.w90')}} {{endtime}}</span>
      </p>
      <div class="content">
        <Row class="details-content" v-show="true">
          <Col span="16">
            <Row>
              <Col span="8" class="detail">
                <div class="d1">
                  <p class="Light-color">{{$t('label.w75')}}</p>
                  <p>{{interest | money}}{{$t('label.w5')}}</p>
                </div>
                <div class="d1">
                  <p class="Light-color allmoney">
                    <span>{{$t('label.w76')}}</span>
                    <i class="icon-active i2">
                      <p class="desc" :style="{textAlign:'left'}">{{$t('label.w137')}} {{$math.eval(`${mfeerate}*100`)}}% / {{loanCycleDay}}{{$t('label.w15')}}</p>
                    </i>
                  </p>
                  <p>
                    <span>{{amount*mfeerate | money}}{{$t('label.w5')}}</span>
                  </p>
                </div>
                <!-- <div class="d1" :style="{marginBottom:0}">
                  <p class="Light-color">优惠减免</p>
                  <p>10.00元</p>
                </div> -->
              </Col>
              <Col span="16" class="feenum">
              <p>{{$t('label.w138')}}：</p>
              <p><span class="am">{{amount+amount*mfeerate+interest | money}}</span>【{{amount+amount*mfeerate+interest | upmoney}}】</p>
                <!-- <p>先息后本（每月付息，到期还本）</p>
                <p>
                  分
                  <span>12</span>期 X 每期
                  <span class="org">12.00元</span> （利息
                  <span>12.00</span>元 + 管理费
                  <span>12.00</span>元）
                </p>
                <p :style="{marginBottom:0}">先息后本（每月付息，到期还本）</p> -->
              </Col>
            </Row>
          </Col>
          <Col span="8" class="release">
            
            <div class="check">
              <Checkbox class="Light-color" @on-change="agreechange"  v-model="agree">
                {{$t('other.w63')}}
                <a href="javascript:;" @click="protocolShow([1,7])">{{$t('other.w59')}}</a>/
                <a href="javascript:;" @click="protocolShow([7,1])">{{$t('other.w61')}}</a>
              </Checkbox>
            </div>
            <div class="btn">
              <Button @click="submit" :loading="loading" :disabled="btnDisabled">{{$t('btn.b32')}}</Button>
            </div>
          </Col>
        </Row>
      </div>
    </div>
    <Protocol ref="Protocol" @yes="agree=true" @no="agree=false"/>
  </div>
</template>

<script>
import Protocol from '@/components/protocolModal'
export default {
  components:{Protocol},
  data(){
    return {
      amount:0,
      rate:0,
      loanCycleDay:1,
      description:'',
      endtime:new Date(Date.now()+1000*60*60*24).format('yyyy-MM-dd'),
      mfeerate:0, //管理费率
      agree:false,
      loading:false
    }
  },
  mounted(){
    this.getinfo()
    this.getMfee()
  },
  methods:{
    async getinfo(){
      let res=await this.$axios.get('/Member/RZJLoan/ToDayRevolveInfo')
      if(res.err) return res.throw()
      if(res.Statu!=1){
        this.$Message.error(this.$t('msg.m48'))
        this.$router.replace({name:'creditCycle'})
        return
      }
      this.amount=res.ToDayRevolveAmount
    },
    async getMfee(){
      // let res=await this.$axios.get('/Member/RZJLoan/LoanCycleManagementFeeRate?loanCycleDay='+this.loanCycleDay)
       let res = await this.$axios.get(
        "/Member/RZJLoan/LoanCycleManagementFeeRate",{
          params:{
            loanCycleDay:this.loanCycleDay,
            thisTimeLoanAmount:this.amount
          }
        }
      );
      if(res.err) return res.throw()
      this.mfeerate=res
    },
    async submit(){
      this.loading=true
      let res=await this.$axios.post('/Member/RZJLoan/RevolveLoan',{
        loanCycleDay:this.loanCycleDay,
        rate:this.rate,
        description:this.description,
      })
      this.loading=false
      res.throw()
      if(!res.err){
        this.$router.replace({name:'loanOrder'})
      }
    },
    protocolShow(arr) {
      this.$refs.Protocol.type = arr;
      this.$refs.Protocol.modal = true;
    },
    agreechange(arr) {
      if (!this.agree) return;
      this.protocolShow([1,7])
    }
  },
  computed:{
    btnDisabled(){
      return (
        this.rate==''||
        this.description.length>20||
        isNaN(this.rate)||
        !this.agree
      )
    },
    interest(){
      return this.amount*(this.rate/100)*this.loanCycleDay/360
    },
  },
  watch:{
    loanCycleDay(){
      this.getMfee()
    }
  }
};
</script>
<style lang="less" scoped>
.creditCycle {
  .tit {
    font-size: 18px;
    font-weight: 500;
    color: rgba(35, 35, 37, 1);
  }
  .org {
    color: #ff6106;
  }
  .content {
    margin-top: 20px;
    .ad {
      padding-left: 110px;
      background: url("../../assets/assetcenter/public_quotes.png") no-repeat;
      background-size: 78px 74px;
      background-position: 80px 150px;
      h3 {
        font-size: 48px;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
      }
      p {
        font-size: 14px;
        color: rgba(179, 179, 182, 1);
      }
      .tip {
        font-weight: 500;
        color: rgba(94, 143, 252, 1);
        font-size: 14px;
        margin-top: 30px;
        span {
          margin-left: 5px;
        }
        i {
          display: inline-block;
          background: url("../../assets/assetcenter/public_hint.png") no-repeat;
          width: 14px;
          height: 13px;
          background-size: cover;
        }
      }
      .desc {
        margin-top: 30px;
        margin-left: 15px;
        position: relative;
        li {
          width: 439px;
          font-size: 14px;
          color: rgba(51, 51, 51, 1);
          margin-bottom: 20px;
          letter-spacing: 1;
          list-style: decimal;
        }
      }
    }
    .bg {
      padding-top: 50px;
      padding-left: 48px;
      .img-bg {
        width: 498px;
        height: 322px;
        background: url("../../assets/assetcenter/credit_bg.png") no-repeat;
        background-size: cover;
      }
    }
  }
  .loanMsg {
    margin-top: 50px;
    .wrMsg {
      width: 100%;
      height: 180px;
      background: #fff;
      color: #232325;
      margin-top: 10px;
      padding: 30px 0 30px 30px;
      .mar-b40 {
        margin-bottom: 40px !important;
      }
      .loan-input {
        .block {
          margin-bottom: 20px;
          /deep/.ivu-input-wrapper {
            width: 176px;
            margin-left: 20px;
            position: relative;
            .ivu-input {
              padding-right: 26px;
            }
          }
          .s1 {
            position: absolute;
            right: 2px;
            top: 10px;
          }
          .s2 {
            width: 500px;
            position: absolute;
            left: 72px;
            bottom: -25px;
            font-size: 12px;
            color: #232325;
            span {
              display: inline;
            }
          }
          /deep/.ivu-select {
            width: 176px;
            margin-left: 20px;
          }
          span {
            color: #7b7b7c;
            width: 56px;
            display: inline-block;
          }
        }
      }
      .block1 {
        padding-left: 20px;
        position: relative;
        p {
          display: inline-block;
          span {
            color: #7b7b7c;
            display: block;
            text-align: center;
          }
        }
        /deep/.ivu-input-wrapper {
          .ivu-input {
            height: 120px;
            resize: none;
          }
          width: 460px;
          margin-left: 20px;
        }
        .s3 {
          position: absolute;
          right: 45px;
          bottom: 5px;
          color: #7b7b7c;
        }
      }
    }
  }
  .confirmMsg {
    margin: 30px 0 30px 0;
    position: relative;
    .time {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #232325;
      font-weight: 500px;
      position: absolute;
      right: 30px;
      top: 10px;
    }
    .content {
      background: #fff;
      margin-top: 10px;
      .details-content {
        padding: 30px 0 30px 30px;
        font-size: 14px;
        color: #232325;
        .detail {
          padding-right: 30px;
          border-right: 1px solid #f0f1f9;
          .d1 {
            display: flex;
            justify-content: space-between;
            margin-bottom: 15px;
            text-align: right;
            .allmoney {
              display: flex;
              align-items: center;
              .i2 {
                background: url("../../assets/borrow/public_moremsg.png")
                  no-repeat;
                background-size: cover;
                margin-left: 5px;
              }
            }
            &:last-child{
              margin-bottom: 0;
            }
          }
          p:last-child {
            font-weight: 500;
            
            del {
              display: block;
            }
          }
        }
        .feenum {
          padding-left: 20px;
          p {
            margin-bottom: 10px;
            &:last-child{
              margin-bottom: 0;
            }
          }
          .am{
            font-size: 20px;
            color: #ff6106;
          }
        }
        .release {
          .check {
            // margin-top: 20px;
            /deep/.ivu-checkbox-wrapper {
              font-size: 14px;
              .ivu-checkbox-inner {
                margin-right: 5px;
              }
            }
          }
          .btn {
            margin-top: 10px;
            /deep/.ivu-btn {
              font-size: 14px;
              width: 344px;
              background: #5e8ffc;
              color: #fff;
            }
          }
        }
      }
    }
  }
  .icon-active {
    display: inline-block;
    position: relative;
    width: 14px;
    height: 14px;
    margin-right: 5px;
    background: url("../../assets/borrow/pic_info@2x.png") no-repeat;
    background-size: cover;
    background-position: -14px 0;
    &::before {
      display: none;
      content: "";
      position: absolute;
      left: 0px;
      top: -12px;
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-top: 8px solid rgba(255, 255, 255, 1);
      z-index: 5;
    }
    .desc {
      display: none;
      width: 162px;
      padding: 10px 0 15px 10px;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
      border-radius: 4px;
      background: #fff;
      font-style: normal;
      font-size: 14px;
      color: #000000;
      position: absolute;
      left: -25px;
      bottom: 26px;
      z-index: 5;
    }
    &:hover {
      &::before {
        display: block;
      }
      .desc {
        display: block;
      }
    }
  }
}
</style>
